export enum TipoPaqueteEcommerceEnum {
    TYPE_DEFAULT = 1998,
    TYPE_A = 1999,
    TYPE_B = 2000,
    TYPE_A_B = 2001
  }